


































import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {BasketDto} from "@swagger";

@Component({
  components: {}
})
export default class BasketSummaryTable extends BasicComponent {

  @Prop(Object) basket: BasketDto;

}

